import React from 'react';
import TextField from '@mui/material/TextField';
import { DesktopDatePicker as MuiDesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

const getErrorMessage = (reason) => {
    switch (reason) {
        case 'invalidDate':
            return 'Enter a valid date.';
        case 'minDate':
            return 'Date is earlier than the allowed minimum.';
        case 'maxDate':
            return 'Date is later than the allowed maximum.';
        case 'disableFuture':
            return 'Date cannot be in the future.';
        case 'disablePast':
            return 'Date cannot be in the past.';
        default:
            return '';
    }
};

const ValidatedDesktopDatePicker = ({ onChange, onError, renderInput, ...pickerProps }) => {
    const [validationError, setValidationError] = React.useState(null);

    const handleChange = (value, keyboardInputValue) => {
        onChange?.(value, keyboardInputValue);
    };

    const handleError = (reason, value) => {
        setValidationError(reason);
        onError?.(reason, value);

        if (reason) {
            onChange?.(value == null ? new Date(Number.NaN) : value);
        }
    };

    const handleRenderInput = (params) => {
        const errorMessage = getErrorMessage(validationError);
        const inputParams = {
            ...params,
            error: Boolean(params.error || errorMessage),
            helperText: errorMessage || params.helperText
        };
        const renderedInput = renderInput ? renderInput(inputParams) : <TextField {...inputParams} />;

        if (!React.isValidElement(renderedInput)) {
            return renderedInput;
        }

        return React.cloneElement(renderedInput, {
            error: Boolean(renderedInput.props.error || params.error || errorMessage),
            helperText: errorMessage || renderedInput.props.helperText || params.helperText
        });
    };

    return (
        <MuiDesktopDatePicker
            {...pickerProps}
            onChange={handleChange}
            onError={handleError}
            renderInput={handleRenderInput}
        />
    );
};

export default ValidatedDesktopDatePicker;
